<section class="mt-2">

    <div *ngIf="tipoPaciente === 'extranjero'">
        <plex-title size="sm" titulo="Registro de paciente extranjero">
            <plex-bool *ngIf="!nuevoPaciente" [(ngModel)]="botonRegistroDNI" label="Registrar DNI argentino"
                       type="slide" (change)="registrarArgentino()" name="registroDNI"
                       [readonly]="disableRegistro || paciente.estado === 'validado'"></plex-bool>
        </plex-title>

        <form #formExtranjero="ngForm">
            <plex-wrapper>
                <plex-text label="Apellido" [(ngModel)]="pacienteExtranjero.apellido" name="apellido"
                           [disabled]="botonRegistroDNI" required="true" (change)="completaExtranjero()">
                </plex-text>
                <plex-text label="Nombre" [(ngModel)]="pacienteExtranjero.nombre" name="nombre"
                           [disabled]="botonRegistroDNI" required="true" (change)="completaExtranjero()">
                </plex-text>

                <plex-select [(ngModel)]="pacienteExtranjero.sexo" label="Seleccione sexo" [data]="sexos" name="sexo"
                             required="true" [disabled]="botonRegistroDNI" placeholder="Seleccione..."
                             (change)="completaExtranjero();mapeoGenero()">
                </plex-select>
            </plex-wrapper>
            <plex-wrapper>
                <plex-datetime label="Fecha de Nacimiento" [max]="hoy" type="date"
                               [(ngModel)]="pacienteExtranjero.fechaNacimiento" name="fechaNacimiento" required="true"
                               grow="3" [disabled]="botonRegistroDNI" (change)="completaExtranjero()">
                </plex-datetime>

                <plex-select label="Tipo de identificación" [(ngModel)]="pacienteExtranjero.tipoIdentificacion"
                             [data]="tipoIdentificacion" name="tipoIdentificacion" placeholder="Seleccione..." grow="3"
                             [disabled]="botonRegistroDNI" (change)="completaExtranjero()">
                </plex-select>
                <plex-text label="Número de identificación" [(ngModel)]="pacienteExtranjero.numeroIdentificacion"
                           name="numeroIdentificacion" grow="3" [disabled]="botonRegistroDNI"
                           (change)="completaExtranjero()">
                </plex-text>
            </plex-wrapper>
        </form>
    </div>

    <form #formBasico="ngForm">
        <ng-container [ngSwitch]="tipoPaciente">
            <div *ngSwitchCase="'bebe'">
                <plex-title size="sm" titulo="Registro de bebé"></plex-title>

                <plex-wrapper>
                    <plex-text label="Apellido" [(ngModel)]="paciente.apellido" name="apellidoBebe" [required]="true"
                               grow="4">
                    </plex-text>

                    <plex-text label="Nombre" [(ngModel)]="paciente.nombre" name="nombreBebe" [pattern]="nombrePattern"
                               [required]="true" grow="4">
                    </plex-text>

                    <plex-select [(ngModel)]="paciente.sexo" label="Seleccione sexo" [data]="sexos" name="sexoBebe"
                                 [required]="true" placeholder="Seleccione..." grow="4" (change)="mapeoGenero()">
                    </plex-select>

                    <plex-datetime label="Fecha y hora de Nacimiento" [max]="hoy" type="datetime"
                                   [readonly]="paciente.estado === 'validado'" [(ngModel)]="paciente.fechaNacimiento"
                                   name="fechaNacimientoBebe" [required]="true" grow="4">
                    </plex-datetime>
                </plex-wrapper>




                <!-- DATOS DEL PROGENITOR PARA EL BEBE-->
                <span class="mt-4">
                    <plex-title size="sm" titulo="Datos de Progenitor/a o tutor/a"></plex-title>
                </span>

                <div class="search-container mt-2" *ngIf="showBuscador; else showRelacion">

                    <paciente-buscar label="Buscar" (searchStart)="onSearchStart()" (searchEnd)="onSearchEnd($event)"
                                     (searchClear)="onSearchClear()">
                    </paciente-buscar>

                    <paciente-listado *ngIf="busquedaTutor?.length" [pacientes]="busquedaTutor"
                                      (selected)="onPacienteSelected($event)" [showRelaciones]="false">
                    </paciente-listado>
                    <div *ngIf="!busquedaTutor?.length && !searchClear" class="alert alert-danger">
                        <plex-icon name="account-alert"></plex-icon> No se encontró ningún paciente..
                    </div>
                </div>

                <ng-template #showRelacion>
                    <plex-wrapper>
                        <plex-text *ngIf="relacionBebe.documento" label="Documento" [(ngModel)]="relacionBebe.documento"
                                   name="documentoRelacion" [readonly]="true">
                        </plex-text>

                        <plex-text *ngIf="relacionBebe.numeroIdentificacion" label="Número de identificación"
                                   [(ngModel)]="relacionBebe.numeroIdentificacion" name="numeroIdentificacionRelacion"
                                   [readonly]="true">
                        </plex-text>

                        <plex-text label="Apellido" [(ngModel)]="relacionBebe.apellido" name="apellidoRelacion"
                                   [readonly]="true">
                        </plex-text>

                        <plex-text label="Nombre" [(ngModel)]="relacionBebe.nombre" name="nombreRelacion"
                                   [readonly]="true">
                        </plex-text>
                    </plex-wrapper>

                    <plex-wrapper>
                        <plex-select [(ngModel)]="relacionBebe.sexo" label="Seleccione sexo" [data]="sexos"
                                     name="sexoRelacion" type="horizontal" [readonly]="true" grow="3">
                        </plex-select>

                        <plex-datetime label="Fecha de Nacimiento" [max]="hoy" type="date" [readonly]="true"
                                       [(ngModel)]="relacionBebe.fechaNacimiento" name="fechaNacimientoRelacion"
                                       grow="3">
                        </plex-datetime>

                        <plex-select [(ngModel)]="relacionBebe.relacion" name="tipoRelacion" label="Relación"
                                     [data]="parentescoModel" [required]="true" placeholder="Seleccione..." grow="3">
                        </plex-select>
                    </plex-wrapper>

                    <div class="row mt-4">
                        <div class="col-4">
                            <plex-button label="Cambiar" type="info" (click)="cambiarRelacion()">
                            </plex-button>
                        </div>
                    </div>
                </ng-template>
            </div>

            <div *ngSwitchCase="'extranjero'">
                <div *ngIf="botonRegistroDNI">
                    <plex-title size="sm" titulo="Registro de paciente argentino"></plex-title>

                    <plex-wrapper>
                        <plex-int class="mr-3" label="Número de DNI ARGENTINO" [(ngModel)]="paciente.documento"
                                  [readonly]="validado || noPoseeDNI" [pattern]="patronDocumento" name="documento"
                                  [required]="true" (change)="checkDisableValidar()" grow="3">
                        </plex-int>
                        <plex-select [(ngModel)]="paciente.sexo" label="Seleccione sexo" [data]="sexos" name="sexo"
                                     required="true" placeholder="Seleccione..." [readonly]="validado"
                                     (change)="mapeoGenero(); checkDisableValidar()" grow="3">
                        </plex-select>

                        <plex-datetime label="Fecha de Nacimiento" [max]="hoy" type="date" [readonly]="true"
                                       [(ngModel)]="paciente.fechaNacimiento" name="fechaNacimiento"
                                       [required]="!noPoseeDNI" grow="3">
                        </plex-datetime>
                    </plex-wrapper>
                    <plex-wrapper>
                        <plex-text label="Apellido" [(ngModel)]="paciente.apellido" name="apellido" required="true"
                                   [readonly]="true">
                        </plex-text>

                        <plex-text label="Nombre" [(ngModel)]="paciente.nombre" name="nombre" required="true"
                                   [readonly]="true">
                        </plex-text>

                        <plex-select [(ngModel)]="paciente.estadoCivil" name="estadoCivil" [data]="estadosCiviles"
                                     label="Seleccione estado Civil">
                        </plex-select>
                    </plex-wrapper>
                </div>
            </div>

            <div *ngSwitchDefault>
                <plex-title size="sm" titulo="Registro de paciente">
                    <plex-bool *ngIf="!validado" [(ngModel)]="noPoseeDNI" label="No posee DNI ARGENTINO" type="slide"
                               name="noPoseDNI" (change)="limpiarDocumento()"></plex-bool>
                </plex-title>
                <plex-wrapper>
                    <plex-int class="mr-3" label="Número de DNI ARGENTINO" [(ngModel)]="paciente.documento"
                              [readonly]=" validado || noPoseeDNI " [pattern]="patronDocumento" name="documento"
                              [required]="!noPoseeDNI" (change)="checkDisableValidar()" grow="4">
                    </plex-int>

                    <plex-select [(ngModel)]="paciente.sexo" label="Seleccione sexo" [data]="sexos" name="sexo"
                                 required="true" placeholder="Seleccione..." [readonly]="validado"
                                 (change)="mapeoGenero();checkDisableValidar()" grow="4">
                    </plex-select>
                    <plex-text *ngIf="!noPoseeDNI" class="mr-3" label="CUIL" [(ngModel)]="paciente.cuil" name="cuil"
                               [pattern]="patronCUIL" grow="4" [required]="false">
                    </plex-text>

                    <plex-datetime label="Fecha de Nacimiento" [max]="hoy" type="date" [readonly]="validado"
                                   [(ngModel)]="paciente.fechaNacimiento" name="fechaNacimiento"
                                   [required]="!noPoseeDNI" grow="4">
                    </plex-datetime>
                </plex-wrapper>

                <plex-wrapper>
                    <plex-text label="Apellido" [(ngModel)]="paciente.apellido" name="apellido" required="true"
                               [readonly]="validado">
                    </plex-text>

                    <plex-text label="Nombre" [(ngModel)]="paciente.nombre" name="nombre" required="true"
                               [readonly]="validado">
                    </plex-text>

                    <plex-select [(ngModel)]="paciente.estadoCivil" name="estadoCivil" [data]="estadosCiviles"
                                 label="Seleccione estado Civil">
                    </plex-select>
                </plex-wrapper>
            </div>
        </ng-container>


        <!-- IDENTIDAD DE GENERO -->
        <form #formGenero="ngForm">

            <ng-container *ngIf="tipoPaciente !== 'bebe'">
                <plex-title titulo="identidad de género" size="sm" class="mt-2"></plex-title>
                <plex-wrapper>
                    <plex-text label="Nombre autopercibido" [(ngModel)]="paciente.alias" name="nombreAutopercibido"
                               [pattern]="nombrePattern" (change)="completaExtranjero()"></plex-text>

                    <plex-select label="Seleccione género autopercibido" [(ngModel)]="paciente.genero"
                                 [data]="generos|async" (change)="completaExtranjero()" name="genero"
                                 [required]="requiereGenero">
                    </plex-select>
                </plex-wrapper>
            </ng-container>
        </form>

        <!-- LUGAR DE NACIMIENTO -->
        <ng-container *ngIf="paciente?.lugarNacimiento">
            <plex-title titulo="Lugar de nacimiento" size="sm">
                <plex-bool class="mr-3" *ngIf="paisActual" [(ngModel)]="nacioPaisActual"
                           label="¿País de {{ paisActual?.[0]?.nombre || '' }}?" name="nacioPaisActual"
                           (change)="changePaisActualNacimiento()">
                </plex-bool>
                <plex-bool class="mr-3" *ngIf="nacioPaisActual && provinciaActual" [(ngModel)]="nacioProvActual"
                           label="¿Provincia de {{provinciaActual.nombre}}?" name="nacioProvActual"
                           (change)="changeProvActualNacimiento()">
                </plex-bool>
                <plex-bool *ngIf="nacioProvActual && localidadActual" [(ngModel)]="nacioLocActual"
                           label="¿Localidad {{localidadActual.nombre}}?" name="nacioLocActual"
                           (change)="changeLocalidadActualNacimiento()">
                </plex-bool>
            </plex-title>

            <plex-grid type="full" size="lg" responsive>
                <plex-wrapper>
                    <plex-select [disabled]="nacioPaisActual" [(ngModel)]="paciente.lugarNacimiento.pais"
                                 name="paisNacimiento" [data]="paisesNacimiento$ | async" idField="nombre"
                                 labelField="nombre" label="País" (change)="loadPaisActualNacimiento()" grow="2">
                    </plex-select>
                    <plex-select *ngIf="nacioPaisActual" [disabled]="nacioProvActual"
                                 [(ngModel)]="paciente.lugarNacimiento.provincia" name="provinciaNacimiento"
                                 [data]="provinciasNacimiento$ | async" idField="nombre" labelField="nombre"
                                 label="Provincia"
                                 (change)="loadLocalidadesNacimiento(paciente.lugarNacimiento.provincia)" grow="2">
                    </plex-select>
                    <plex-text *ngIf="!nacioPaisActual || (nacioPaisActual && !nacioProvActual)" label="Lugar"
                               [(ngModel)]="paciente.lugarNacimiento.lugar" name="lugarNacimientoTexto" grow="2">
                    </plex-text>
                    <plex-select *ngIf="nacioPaisActual && nacioProvActual" [disabled]="nacioLocActual"
                                 label="Localidad" [required]="nacioProvActual"
                                 [(ngModel)]="paciente.lugarNacimiento.localidad" name="localidadNacimiento"
                                 [data]="localidadesNacimiento$ | async" labelField="nombre"
                                 (change)="updateNacioLocalidadActual()" grow="2">
                    </plex-select>
                </plex-wrapper>
            </plex-grid>
        </ng-container>

        <ng-container *ngIf="paciente?.id || pacienteFallecido">
            <plex-bool name="fallecido" type="slide" label="Paciente fallecido" [(ngModel)]="pacienteFallecido"
                       (change)="onFallecidoChange()">
            </plex-bool>

            <div *ngIf="pacienteFallecido">
                <plex-title titulo="Fecha de defunción" size="sm" class="mt-2"></plex-title>

                <plex-grid type="auto" size="sm" cols="4" class="mt-2">
                    <plex-datetime label="Fecha de defunción" [(ngModel)]="fechaFallecimientoTemporal"
                                   name="fechaFallecimientoTemporal" [required]="pacienteFallecido" [max]="hoy"
                                   [min]="paciente?.fechaNacimiento" type="date">
                    </plex-datetime>

                    <plex-button type="success" icon="check" class="align-self-end" style="width: 50px;"
                                 (click)="guardarFallecimiento()"
                                 [disabled]="!fechaFallecimientoTemporal || fechaFallecimientoTemporal > hoy"
                                 tooltip="Guardar" titlePosition="top">
                    </plex-button>
                </plex-grid>
            </div>

        </ng-container>

        <!-- Reporte de error en datos -->
        <ng-container *ngIf="validado">
            <plex-bool [(ngModel)]="reportarError" name="reportarError" type="slide" class="mt-4"
                       label="Los datos validados con RENAPER tienen un error y quiero reportarlo"
                       (change)="registrarError()">
            </plex-bool>
            <div class="mt-2" *ngIf="reportarError">

                <plex-text label="Ingrese apellido correcto" [(ngModel)]="pacienteEditado.apellido" name="apellidoError"
                           [required]="true" [debounce]="500"
                           (change)="verificarNombreApellido({apellido: pacienteEditado.apellido})">
                </plex-text>
                <plex-text label="Ingrese nombre correcto" [(ngModel)]="pacienteEditado.nombre" name="nombreError"
                           [required]="true" [debounce]="500"
                           (change)="verificarNombreApellido({nombre: pacienteEditado.nombre})">
                </plex-text>
                <plex-datetime label="Ingrese fecha de nacimiento correcta" type="date" [required]="true"
                               [debounce]="500" [(ngModel)]="pacienteEditado.fechaNacimiento" name="fechaError"
                               (change)="verificarNombreApellido({fechaNacimiento: pacienteEditado.fechaNacimiento})">
                </plex-datetime>
                <br>
                <plex-label size="md" titulo="Si hay un error en RENAPER, la persona deberá informar el
                                            problema en la delegación de RENAPER más cercana a su domicilio para corregir la situación de su
                                            DNI." type="info">
                    <plex-icon name="cruz" size="xs"></plex-icon>
                </plex-label>
                <plex-label size="md" titulo="Le recordamos que el apartado Notas lo puede utilizar
                                para aclarar asuntos referidos a datos filiatorios." type="info">
                    <plex-icon name="informacion" size="xs"></plex-icon>
                </plex-label>
            </div>
        </ng-container>
    </form>

</section>